import { useAuth, useTranslation } from '@/contexts';
import { ThemeToggle } from './ThemeToggle';
import styles from './TopBar.module.css';

export function TopBar() {
  const { user, role } = useAuth();
  const { t } = useTranslation();

  const initial = user.name.trim().charAt(0).toUpperCase() || '?';
  const roleLabel = t(`topBar.roles.${role}`);

  return (
    <header className={styles.topBar}>
      <div className={styles.left}>
        <span className={styles.breadcrumb}>{t('topBar.administration')}</span>
      </div>
      <div className={styles.right}>
        <div className={styles.userBadge}>
          <span className={styles.userAvatar} aria-hidden="true">
            {initial}
          </span>
          <span className={styles.userText}>
            {/* Имя и фамилия целиком: /init отдаёт их одной строкой. */}
            <span className={styles.userName}>{user.name || t('topBar.adminFallback')}</span>
            <span className={styles.userRole}>{roleLabel}</span>
          </span>
        </div>

        <ThemeToggle />
      </div>
    </header>
  );
}
